export default {
    CANNOT_ACCESS_LOOTBAG: 'Hindi pa pwedeng ma access ang lootbag na ito',
    REQUIRES_ACHIEVEMENT: "Ang item na ito ay kailangan ng Secret Achievement upang magamit 'to",
    REQUIRES_QUEST: 'Kailangan mong tapusin ang {{quest}} para ma equip ito.',
    SKILL_LEVEL_REQUIREMENT_EQUIP:
        'Iyong {{skill}} ay kailangang maging {{level}} para ma equip ito.',
    TOTAL_LEVEL_REQUIREMENT: 'Your total level must be at least {{level}} to equip this item.'
} as const;
